import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';

import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../model/https';
import { ITrackPackageResponse } from '../../model/trackPackage.model';
import useHttps from '../useHttps';

const usePackageInfo = () => {
  const request = useHttps();
  const { packageId } = useParams();
  const [packageInfoloading, setPackageInfoLoading] = useState(false);
  const [packageInfo, setPackageInfo] = useState<ITrackPackageResponse>();

  useEffect(() => {
    const getPackageInfo = () => {
      const url: HttpConfig = {
        url: `general-service/packages/${packageId}`,
        method: 'get',
      };

      request(
        url,
        onPackageInfoSuccess,
        setPackageInfoLoading,
        onPackageInfoError
      );
    };
    getPackageInfo();
  }, [request, packageId]);

  const onPackageInfoError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ?? 'Error occur while tracking package'
    );
  };

  const onPackageInfoSuccess = ({
    message,
    data,
  }: SuccessHttpResponse<ITrackPackageResponse>) => {
    console.log('>>>>-----W))))000W----->>>', data);
    setPackageInfo(data);

    // toast.success(message);
  };

  return { packageInfo, packageInfoloading };
};

export default usePackageInfo;
